/**
 * Doelpad van een `ui_handoff` uit de assistent valideren vóór navigate().
 *
 * Alleen een allowlist van interne routes: een los "begint met /"-filter liet
 * `/projects/../../\evil.example` door, dat React Router normaliseert naar
 * `/\evil.example` → de browser leest dat als https://evil.example/ (open redirect).
 */

// Alleen een Airtable record-id: de overzichtroute zoekt daarop; de engine (tools/handoffs.py)
// zet een projectnummer al om naar het record-id.
const VEILIG_PROJECT_ID = 'rec[A-Za-z0-9]{14}';

const TOEGESTANE_ROUTES = [
  new RegExp(`^/projects/${VEILIG_PROJECT_ID}$`),
];

// eslint-disable-next-line no-control-regex
const CONTROLTEKENS = /[\u0000-\u001f\u007f]/;

/** Geeft het pad terug als het een toegestane interne route is, anders null. */
export function veiligHandoffPad(target) {
  if (typeof target !== 'string' || target.length === 0 || target.length > 200) return null;
  if (target.includes('\\') || target.includes('..') || target.startsWith('//')
      || target.includes('//') || CONTROLTEKENS.test(target)) {
    return null;
  }
  return TOEGESTANE_ROUTES.some((re) => re.test(target)) ? target : null;
}
